/* Pendelle — JS propre à la zone home (fichier de l’agent ACCUEIL). Chargé en defer après pendelle.js (window.PD disponible).
   Mini-formulaire « Trouvez votre luminaire » de l'accueil (.quiz[data-pd-quiz]) : mêmes étapes et mêmes gestes que la maquette
   (pièce → surface → hauteur → style). Au choix du style, ouverture de la page de l'outil avec les réponses dans l'adresse :
   <data-url>?piece=…&surface=…&hauteur=…&style=…  */
(function () {
  'use strict';
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function diamRange(S) { var D = 16 * Math.sqrt(S); var a = Math.max(25, Math.round(D * 0.9 / 5) * 5), b = Math.round(D * 1.05 / 5) * 5; if (b <= a) b = a + 5; return [a, b, D]; }

  function Quiz(el) {
    if (el.__pdq) return; el.__pdq = 1;
    var surf0 = parseInt(el.getAttribute('data-surf'), 10) || 18;
    var s = { step: 0, room: null, surf: surf0, h: null, style: null };
    var steps = $$('.qstep', el), prog = $$('.qprog li', el);

    function paintSurf() {
      var r = diamRange(s.surf), v = $('[data-qs]', el), d = $('[data-qd]', el), pl = $('[data-qplan]', el), rg = $('[data-qrange]', el);
      if (v) v.textContent = s.surf;
      if (d) d.textContent = r[0] + ' à ' + r[1] + ' cm';
      if (pl) { pl.style.width = pl.style.height = Math.round(30 + s.surf) + 'px'; pl.style.setProperty('--d', Math.round(r[2] / 4) + 'px'); }
      if (rg && +rg.value !== s.surf) rg.value = s.surf;
    }
    function pressed(attr, val) { $$('[' + attr + ']', el).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute(attr) === val)); }); }
    function show() {
      steps.forEach(function (st) { st.hidden = +st.getAttribute('data-qstep') !== s.step; });
      prog.forEach(function (li, i) { li.classList.toggle('on', i <= s.step); });
      pressed('data-qroom', s.room); pressed('data-qh', s.h); pressed('data-qst', s.style);
      if (s.step === 1) paintSurf();
      if (window.PD && PD.nb) PD.nb(el);
    }
    function send() {
      s.step = 4; prog.forEach(function (li) { li.classList.add('on'); });
      var base = el.getAttribute('data-url') || '/pages/trouver-mon-luminaire';
      var q = 'piece=' + encodeURIComponent(s.room || '') + '&surface=' + s.surf + '&hauteur=' + encodeURIComponent(s.h || '') + '&style=' + encodeURIComponent(s.style || 'tous');
      window.location.href = base + (base.indexOf('?') > -1 ? '&' : '?') + q;
    }
    function go1(b) {
      $$('.qo', b.closest('.qstep')).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      setTimeout(function () { if (s.step === 3) send(); else { s.step++; show(); } }, RM ? 0 : 260);
    }
    el.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-qroom]'))) { s.room = b.getAttribute('data-qroom'); go1(b); return; }
      if ((b = e.target.closest('[data-qh]'))) { s.h = b.getAttribute('data-qh'); go1(b); return; }
      if ((b = e.target.closest('[data-qst]'))) { s.style = b.getAttribute('data-qst'); go1(b); return; }
      if (e.target.closest('[data-qnext]')) { s.step++; show(); return; }
      if (e.target.closest('[data-qback]')) { s.step = Math.max(0, s.step - 1); show(); return; }
    });
    el.addEventListener('input', function (e) { if (e.target.matches('[data-qrange]')) { s.surf = +e.target.value; paintSurf(); } });
    /* retour arrière du navigateur depuis la page de l'outil : on revient à l'étape du style */
    window.addEventListener('pageshow', function (ev) { if (ev.persisted && s.step === 4) { s.step = 3; show(); } });
    show();
  }

  function init(scope) { $$('.quiz[data-pd-quiz]', scope || document).forEach(Quiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
